import React, { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Auditoria() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/auditoria").then((r) => setLogs(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-black tracking-tight">Auditoría</h2>
        <p className="text-sm text-muted-foreground mt-1">Registro histórico de acciones críticas.</p>
      </div>
      <Card>
        <CardContent className="p-0">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Fecha</TableHead>
                <TableHead>Usuario</TableHead>
                <TableHead>Acción</TableHead>
                <TableHead>Entidad</TableHead>
                <TableHead>Detalle</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {logs.map((l) => (
                <TableRow key={l.id}>
                  <TableCell className="text-xs">{fmtDate(l.created_at)}</TableCell>
                  <TableCell className="text-xs">{l.user_email || "-"}</TableCell>
                  <TableCell className="font-bold text-xs">{l.accion}</TableCell>
                  <TableCell className="text-xs text-muted-foreground">{l.entidad}</TableCell>
                  <TableCell className="text-xs text-muted-foreground truncate max-w-xs">{l.detalle ? JSON.stringify(l.detalle) : "-"}</TableCell>
                </TableRow>
              ))}
              {logs.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground py-8">Sin registros</TableCell></TableRow>}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
